import { render, staticRenderFns } from "./UnmanagedBeneficiaryWarning.vue?vue&type=template&id=510b124a"
import script from "./UnmanagedBeneficiaryWarning.vue?vue&type=script&lang=js"
export * from "./UnmanagedBeneficiaryWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports